import Model, { type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { ParityInsightSegmentationItem } from 'lumen/models';
import type { BreakdownItem } from 'lumen/models/parity/insight/segmentation-item';

export default class ParityInsightSegmentationData extends Model {
  [Type] = 'parity/insight/segmentation-data' as const;

  @hasMany('parity/insight/segmentation-item', { async: false, inverse: null })
  declare all: HasMany<ParityInsightSegmentationItem>;

  @hasMany('parity/insight/segmentation-item', { async: false, inverse: null })
  declare brand_id: HasMany<BreakdownItem>;

  @hasMany('parity/insight/segmentation-item', { async: false, inverse: null })
  declare channel: HasMany<BreakdownItem>;

  @hasMany('parity/insight/segmentation-item', { async: false, inverse: null })
  declare channel_type: HasMany<BreakdownItem>;

  @hasMany('parity/insight/segmentation-item', { async: false, inverse: null })
  declare issue_type: HasMany<ParityInsightSegmentationItem>;

  @hasMany('parity/insight/segmentation-item', { async: false, inverse: null })
  declare market_id: HasMany<BreakdownItem>;

  @hasMany('parity/insight/segmentation-item', { async: false, inverse: null })
  declare platform: HasMany<BreakdownItem>;

  @hasMany('parity/insight/segmentation-item', { async: false, inverse: null })
  declare source: HasMany<BreakdownItem>;

  @hasMany('parity/insight/segmentation-item', { async: false, inverse: null })
  declare subscription_id: HasMany<BreakdownItem>;

  @hasMany('parity/insight/segmentation-item', { async: false, inverse: null })
  declare variance_bucket: HasMany<ParityInsightSegmentationItem>;
}
